import React from 'react';

import { ChallengeResultType } from 'interfaces';
import { Text } from 'components';
// eslint-disable-next-line import/no-cycle
import { PhotoSizeType } from '../UsersPhoto';
// eslint-disable-next-line import/no-cycle
import { StyledCircle } from './PhotoRank.styles';

type PhotoRankType = {
  challengeResults?: ChallengeResultType;
  size: PhotoSizeType;
  isHighlighted?: boolean;
};

const PhotoRank = ({
  challengeResults,
  size,
  isHighlighted = false,
}: PhotoRankType): JSX.Element => (
  <>
    {challengeResults?.rank && (
      <StyledCircle size={size} isHighlighted={isHighlighted}>
        <Text color="white" weight="bold" isParagraph={false}>
          {challengeResults?.rank}
          <sup>e</sup>
        </Text>
      </StyledCircle>
    )}
  </>
);

export default PhotoRank;
